import { Duration } from 'luxon';

import dateIncrements from './dateIncrements';  

const getColDurationAsMs = (mode) => {
  const { bottomType, quantity } = dateIncrements[mode];
  return Duration.fromObject({ [bottomType]: quantity }).as('milliseconds');
};

export default getColDurationAsMs;
